<template>
  <div>
    <w-title-bar :title="title" textColor="#000000"></w-title-bar>
    <div id="content" class="about_background content">
      <el-card class="content-position no-padding">
        <div class="clearfix header">
          <img class="my_head_background" src="static/product_head.png" />
          <img class="my_head" src="static/about_us.png" />
          <span style="font-family:PingFang">{{i18n.title}}</span>
        </div>
        <el-form :label-position="labelPosition" label-width="80px" :model="formIntroduction">
          <div style="font-family:PingFang">{{formIntroduction.descOne}}</div>
        </el-form>
        <img class="my_center_circle" :src="srcFlag?'static/aboutimg02.jpg':'static/aboutimg02e.jpg'"/>
        <el-form :label-position="labelPosition" label-width="80px" :model="formIntroduction" style="margin-top:5px">
          <div style="font-family:PingFang">{{formIntroduction.descTwo}}</div>
        </el-form>
      </el-card>

      
    </div>
  </div>
</template>

<script>
import wTitleBar from "@/components/w-titleBar";
export default {
  name: "about",
  components: {
    wTitleBar,
  },
  data() {
    return {
      title: "",
      srcFlag: true,
      formIntroduction: {
        descOne: '',
        descTwo: ''
     },
    };
  },
  computed: {
    i18n() {
      this.title = this.$t('about.title');
      this.formIntroduction.descOne = this.$t('about.descOne');
      this.formIntroduction.descTwo = this.$t('about.descTwo');
      return this.$t('about');
    }
  },
  mounted() {
    let divContent = document.getElementById("content").clientHeight;
    let screenHeight = document.body.clientHeight;
    document.getElementById("content").style.cssText =
      "height: " + (divContent - 44) + "px;";
    if(navigator.language.indexOf("zh") != -1){
      this.srcFlag = true;
    } else {
      this.srcFlag = false;
    }
    
  },
  methods: {
    goBack() {
      this.$router.back();
    },
  },
};
</script>

<style>
.about_background {
  background-color: #f6f6f6;
}
.content {
  width: 100vw;
  height: 100vh;
  overflow: scroll;
}
.success_top {
  width: 100vw;
}
.success_center {
  width: 100vw;
  margin-top: -50%;
}
.text-pass {
  margin-top: -44%;
  text-align: center;
  font-size: 20px;
  font-family: PingFang;
  font-weight: 500;
  color: rgba(43, 27, 2, 1);
  line-height: 56px;
}
.text-test {
  font-size: 15px;
  text-align: center;
  font-family: PingFang;
  font-weight: 500;
  color: rgba(208, 2, 27, 1);
  line-height: 37px;
}
.picture-position {
  margin-top: 18%;
  margin-left: 10px;
  margin-right: 10px;
  height: 250px;
  border-radius: 20px;
}
.image {
  width: 100%;
  display: block;
}
.content-position {
  margin-top: 2%;
  margin-left: 10px;
  margin-right: 10px;
  border-radius: 20px;
}
.my_head {
  width: 1.3rem;
  height: 1.2rem;
  margin-right: 5px;
  text-align: center;
  font-size: 18px;
  vertical-align: middle;
  margin-left: -240px;
}
.my_head_background {
  margin-left: -20px;
  height: 2.2rem;
  margin-right: 5px;
  text-align: center;
  font-size: 18px;
  vertical-align: middle;
}
.header {
  padding: 10px 0px;
  box-sizing: border-box;
  margin-top: -10px;
}
.no-padding {
  padding: 0px;
}
.el-carousel__item img {
  height: 200px;
  clear: both;
  display: block;
  margin: auto;
}
.my_center_circle{
  height: 12rem;
  transform: translate(29%, 3%);
  text-align: center;
  font-size: 18px;
  vertical-align: middle;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/home/about.vue